<p>footer works!</p>
<nav>
    <a routerLink="/contador">contador</a>
    <a routerLink="/curriculum">curriculum</a>
  </nav>
<router-outlet></router-outlet>